(function () {
  var cartQty = {};
  var syncVersion = 0;
  var cartUrl = function (path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path; };

  function readResponse(response) {
    return response.json().then(function (body) {
      if (!response.ok || body.status) throw new Error(body.description || body.message || (window.cartStrings && window.cartStrings.error) || 'Košík se nepodařilo aktualizovat. Zkuste to znovu.');
      return body;
    });
  }

  function variantId(button) {
    var form = button.closest('form');
    var input = form && form.querySelector('input[name="id"]');
    var actions = button.closest('.card-product-actions');
    return Number(button.dataset.mobVariantId || (actions && actions.dataset.variantId) || (input && input.value));
  }

  function standardItem(item) {
    return !item.selling_plan_allocation && !Object.keys(item.properties || {}).length;
  }

  function paidItems(cart, id) {
    return cart.items.filter(function (entry) { return entry.variant_id === id && standardItem(entry); });
  }

  function setPaidQuantity(cart, id, desired) {
    var items = paidItems(cart, id);
    var total = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    if (total === desired) return Promise.resolve(cart);
    // A gift discount can split one paid variant into several lines. The selector
    // controls their total; changing one line to the total would add extra units.
    var item = desired < total ? items[items.length - 1] : items[0];
    var quantity = item ? Math.max(0, item.quantity + desired - total) : desired;
    return fetch(cartUrl(item ? 'cart/change.js' : 'cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: item ? item.key : id, quantity: quantity })
    }).then(readResponse).then(function (body) {
      if (body.items) return body;
      return fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(readResponse);
    }).then(function (updated) {
      var remaining = paidItems(updated, id).reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
      // Re-read keys from each response: applying a discount can change them.
      if (desired < total && remaining > desired && remaining < total) return setPaidQuantity(updated, id, desired);
      return updated;
    });
  }

  function updateDropdown(select) {
    var row = select.closest('.ilico-mob-qty-row');
    var button = row && row.querySelector('[data-mob-cart-btn]');
    if (!button || button.disabled) return;
    var quantity = cartQty[variantId(button)] || 1;
    if (!Array.from(select.options).some(function (option) { return Number(option.value) === quantity; })) {
      select.add(new Option(quantity + ' ks', String(quantity)));
    }
    select.value = String(quantity);
    var label = row.querySelector('.ilico-mob-qty-label');
    if (label) label.textContent = quantity + ' ks';
  }

  function rememberCart(cart) {
    cartQty = {};
    cart.items.filter(standardItem).forEach(function (item) {
      cartQty[item.variant_id] = (cartQty[item.variant_id] || 0) + item.quantity;
    });
    document.querySelectorAll('[data-mob-qty-select]').forEach(updateDropdown);
  }

  function syncFromCart() {
    var version = ++syncVersion;
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(readResponse).then(function (cart) {
      if (version === syncVersion) rememberCart(cart);
    }).catch(function () {});
  }

  function showError(button, message) {
    var root = button.closest('product-form') || button.closest('.card-product-actions') || button.parentElement;
    var error = root.querySelector('[data-mobile-cart-error]');
    if (!error) {
      error = document.createElement('div');
      error.dataset.mobileCartError = '';
      error.className = 'form-status form-status-error';
      error.setAttribute('role', 'alert');
      root.appendChild(error);
    }
    error.textContent = message;
    error.hidden = !message;
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-mob-qty-select]');
    if (!select) return;
    var label = select.closest('.ilico-mob-qty-row').querySelector('.ilico-mob-qty-label');
    if (label) label.textContent = select.value + ' ks';
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mob-cart-btn]');
    if (!button || button.disabled) return;
    var row = button.closest('.ilico-mob-qty-row');
    var select = row && row.querySelector('[data-mob-qty-select]');
    var id = variantId(button);
    var desired = select && Number(select.value);
    if (!id || !Number.isInteger(desired) || desired < 1) return;
    event.preventDefault();
    ++syncVersion;
    showError(button, '');
    button.disabled = true;
    button.classList.remove('ilico-mob-added');
    button.classList.add('ilico-mob-loading');

    fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(readResponse).then(function (cart) {
      return setPaidQuantity(cart, id, desired);
    }).then(function (cart) {
      if (!window.ilicoKosik || !document.querySelector('.ilico-evo-cart')) return cart;
      return window.ilicoKosik.obnov().then(function (fresh) {
        if (!fresh) throw new Error((window.cartStrings && window.cartStrings.error) || 'Košík se nepodařilo aktualizovat. Zkuste to znovu.');
        return fresh;
      });
    }).then(function (cart) {
      ++syncVersion;
      button.disabled = false;
      rememberCart(cart);
      if (window.ilicoKosik) window.ilicoKosik.aktualizuj(cart);
      var minicart = document.querySelector('mini-cart');
      if (minicart) Promise.resolve(minicart.updateSectionContents()).catch(function () {});
      button.classList.add('ilico-mob-added');
      clearTimeout(button._mobT);
      button._mobT = setTimeout(function () { button.classList.remove('ilico-mob-added'); }, 1500);
      document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { context: 'MobileQtyUpdate', cart: cart } }));
    }).catch(function (error) {
      showError(button, error.message);
    }).finally(function () {
      button.classList.remove('ilico-mob-loading');
      button.disabled = false;
    });
  });

  ['cart:item-add', 'cart:item-remove', 'cart:item-quantity-update', 'ilico:kosik-zmena'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.detail && event.detail.context === 'MobileQtyUpdate') return;
      var cart = name === 'ilico:kosik-zmena' ? event.detail : event.detail && event.detail.cart;
      if (cart && cart.items) { ++syncVersion; rememberCart(cart); }
      else syncFromCart();
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFromCart);
  else syncFromCart();
})();

/* ── Scroll wrapper + šipky pro size/color badges ── */
(function() {
  if (window.innerWidth > 749) return;

  function wrapScrollable(selector) {
    document.querySelectorAll(selector).forEach(function(el) {
      /* Přeskoč pokud už je obaleno */
      if (el.parentElement && el.parentElement.classList.contains('ilico-scroll-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'ilico-scroll-wrap';

      var arrowL = document.createElement('span');
      arrowL.className = 'ilico-scroll-arrow ilico-arrow-left';
      arrowL.innerHTML = '\u2039';

      var arrowR = document.createElement('span');
      arrowR.className = 'ilico-scroll-arrow ilico-arrow-right';
      arrowR.innerHTML = '\u203A';

      el.parentNode.insertBefore(wrap, el);
      wrap.appendChild(arrowL);
      wrap.appendChild(el);
      wrap.appendChild(arrowR);

      arrowL.addEventListener('click', function() {
        el.scrollBy({ left: -80, behavior: 'smooth' });
      });
      arrowR.addEventListener('click', function() {
        el.scrollBy({ left: 80, behavior: 'smooth' });
      });

      updateArrows(wrap, el);
      createDots(wrap, el);

      el.addEventListener('scroll', function() {
        updateArrows(wrap, el);
        updateDots(wrap, el);
      });
    });
  }

  function updateArrows(wrap, el) {
    var canLeft = el.scrollLeft > 3;
    var canRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 3;

    if (canLeft) wrap.classList.add('ilico-can-left');
    else wrap.classList.remove('ilico-can-left');

    if (canRight) wrap.classList.add('ilico-can-right');
    else wrap.classList.remove('ilico-can-right');
  }

  function createDots(wrap, el) {
    var items = el.querySelectorAll('.ilico-size-badge, .ilico-color-swatch');
    if (items.length < 2) return;
    if (el.scrollWidth <= el.clientWidth + 3) return;

    var MAX_DOTS = 5;
    var numDots = Math.min(items.length, MAX_DOTS);
    var maxScroll = el.scrollWidth - el.clientWidth;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ilico-scroll-dots';
    dotsWrap.dataset.numDots = numDots;
    dotsWrap.dataset.maxScroll = maxScroll;
    for (var i = 0; i < numDots; i++) {
      var dot = document.createElement('button');
      dot.className = 'ilico-scroll-dot';
      dot.type = 'button';
      dot.dataset.index = i;
      dot.addEventListener('click', (function(idx, nd, ms) {
        return function() {
          var targetScroll = nd <= 1 ? 0 : (ms * idx / (nd - 1));
          el.scrollTo({ left: targetScroll, behavior: 'smooth' });
        };
      })(i, numDots, maxScroll));
      dotsWrap.appendChild(dot);
    }
    wrap.parentNode.insertBefore(dotsWrap, wrap.nextSibling);
    updateDots(wrap, el);
  }

  function updateDots(wrap, el) {
    var dotsWrap = wrap.nextElementSibling;
    if (!dotsWrap || !dotsWrap.classList.contains('ilico-scroll-dots')) return;
    var dots = dotsWrap.querySelectorAll('.ilico-scroll-dot');
    var numDots = dots.length;
    if (numDots < 1) return;
    var maxScroll = el.scrollWidth - el.clientWidth;
    var progress = maxScroll > 0 ? el.scrollLeft / maxScroll : 0;
    var activeIdx = Math.round(progress * (numDots - 1));
    for (var j = 0; j < numDots; j++) {
      if (j === activeIdx) dots[j].classList.add('active');
      else dots[j].classList.remove('active');
    }
  }

  /* ── Equalizer: zarovná card-info výšky across karet ve stejném řádku ── */
  function eqCards() {
    if (window.innerWidth > 749) return;
    var cards = Array.from(document.querySelectorAll('product-card.card-product'));
    if (cards.length < 2) return;

    var sels = ['.card-info', '.ilico-variants-zone', '.card-footer-intro', '.price'];

    /* Reset */
    cards.forEach(function(c) {
      sels.forEach(function(s) {
        var el = c.querySelector(s);
        if (el) el.style.minHeight = '';
      });
    });

    /* Seskup do řádků dle Y pozice */
    var rows = [];
    cards.forEach(function(c) {
      var r = c.getBoundingClientRect();
      if (r.width < 10) return;
      var y = Math.round(r.top);
      var row = null;
      for (var i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].y - y) < 40) { row = rows[i]; break; }
      }
      if (!row) { row = { y: y, cards: [] }; rows.push(row); }
      row.cards.push(c);
    });

    /* Zarovnej výšky sekcí */
    rows.forEach(function(row) {
      var rc = row.cards;
      if (rc.length < 2) return;
      for (var si = 0; si < sels.length; si++) {
        var sel = sels[si];
        var maxH = 0, els = [], skip = false;
        rc.forEach(function(c) {
          var el = c.querySelector(sel);
          if (!el) { skip = true; return; }
          if (sel === '.ilico-variants-zone' && el.children.length < 1) { skip = true; return; }
          els.push(el);
          var h = el.offsetHeight;
          if (h > maxH) maxH = h;
        });
        if (!skip && maxH > 0 && els.length > 1) {
          els.forEach(function(el) { el.style.minHeight = maxH + 'px'; });
        }
      }
    });
  }

  function init() {
    wrapScrollable('.ilico-size-badges');
    wrapScrollable('.ilico-color-swatches');
    /* Po vytvoření scroll wrapperů spusť equalizaci */
    setTimeout(eqCards, 50);
    setTimeout(eqCards, 300);
    setTimeout(eqCards, 800);
    setTimeout(eqCards, 2000);
  }

  window.addEventListener('load', function() {
    setTimeout(init, 400);
  });
  /* Při lazy-load obrázcích může layout skočit — přepočítej */
  document.addEventListener('lazyloaded', function() {
    setTimeout(eqCards, 100);
  });
  window.addEventListener('resize', function() {
    document.querySelectorAll('.ilico-scroll-wrap').forEach(function(wrap) {
      var el = wrap.querySelector('.ilico-size-badges, .ilico-color-swatches');
      if (el) updateArrows(wrap, el);
    });
    setTimeout(eqCards, 200);
  });
})();

